export const formatNumber = (number: number): number =>
  Math.round(number * 100) / 100;

export const formatPercentage = (percentage: number): string =>
  `${formatNumber(percentage)}%`;
